import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { environment } from '../../../../environments/environment';
import * as moment from 'moment';
import { ProductPricelist } from '../../payment/models/product-pricelist';
import { GlobalSettings } from 'src/environments/global-settings';

export class Partner {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  zip: string;
  phone: string;
  gender: string;
  dateOfBirth: Date;
  offersMedia: boolean;
  offersEmail: boolean;
  offersPhone: boolean;
  waiver: boolean;
  children: Partner[] = [];
  ref: string;
  waiverUrl: string;
  _dateOfBirthMoment: moment.Moment;
  productPricelist: ProductPricelist = null;
  title: number;
  lang: string;
  street = '';
  city: string;
  barcode: string;
  accountBalance: number;
  additionalFields = {};
  termsOfUseAndPrivacyAccepted: boolean;
  webshopOrderCount: number;

  public constructor(init?: Partial<Partner>) {
    Object.assign(this, init);
  }

  static createFromAny(object: any): Partner {
    if (object === null || object === undefined) {
      return null;
    }

    const partner = new Partner();
    partner.id = object.id;
    if (object.firstName) {
      partner.firstName = object.firstName;
    }
    if (object.lastName) {
      partner.lastName = object.lastName;
    }
    if (object.zip) {
      partner.zip = object.zip;
    }
    partner.phone = object.phone;
    partner.gender = object.gender;
    if (object.dateOfBirth) {
      partner.dateOfBirth = new Date(object.dateOfBirth);
      if (partner.dateOfBirth) {
        partner._dateOfBirthMoment = moment(partner.dateOfBirth.toJSON());
      } else {
        partner._dateOfBirthMoment = moment(GlobalSettings.DateNow);
      }
    }
    partner.email = object.email;
    partner.offersMedia = object.offersMedia;
    partner.offersEmail = object.offersEmail;
    partner.offersPhone = object.offersPhone;
    partner.waiver = object.waiver;
    partner.ref = object.ref;
    partner.waiverUrl = object.waiverUrl;
    partner.lang = object.lang;
    partner.barcode = object.barcode;

    partner.productPricelist = object.productPricelist ? ProductPricelist.createFromAny(object.productPricelist) : null;

    partner.title = object.title;
    partner.street = object.street ? object.street : '';
    partner.city = object.city || '';
    partner.accountBalance = object.account_balance;
    partner.termsOfUseAndPrivacyAccepted = object.terms_of_use_and_privacy_accepted;
    partner.webshopOrderCount = object.webshopOrderCount || 0;

    if (object.additionalFields) {
      partner.additionalFields = object.additionalFields;
    }

    if (object.children === null || object.children === undefined) {
      return partner;
    }

    for (const child in object.children) {
      if (child != null) {
        partner.children.push(Partner.createFromAny(child));
      }
    }
    return partner;
  }

  toJSON(): any {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      zip: this.zip,
      phone: this.phone,
      gender: this.gender,
      dateOfBirth: this.dateOfBirth ? environment.globalSettings.getIsoDateStr(this.dateOfBirth.getFullYear(), this.dateOfBirth.getMonth() + 1, this.dateOfBirth.getDate()) : undefined,
      offersMedia: this.offersMedia,
      offersEmail: this.offersEmail,
      offersPhone: this.offersPhone,
      waiver: this.waiver,
      ref: this.ref,
      waiverUrl: this.waiverUrl,
      productPricelist: this.productPricelist,
      title: this.title,
      lang: this.lang,
      street: this.street,
      city: this.city,
      barcode: this.barcode,
      additionalFields: this.additionalFields,
      terms_of_use_and_privacy_accepted: this.termsOfUseAndPrivacyAccepted,
      webshopOrderCount: this.webshopOrderCount,
    };
  }

  get clone(): Partner {
    return JSONUtilites.fromJSON<Partner>(null, JSON.stringify(this), Partner.createFromAny);
  }

  get age(): number {
    return environment.globalSettings.getAgeFromDate(this.dateOfBirth) || 0;
  }

  get name(): string {
    let name = this.firstName || '';
    if (this.lastName) {
      if (name) {
        name += ' ';
      }
      name += this.lastName;
    }

    return name || this.email || '';
  }

  isChildEquals(child: Partner): boolean {
    return this.firstName === child.firstName
      && this.lastName === child.lastName
      && this.dateOfBirth === child.dateOfBirth
      && this.gender === child.gender;
  }

  get dateOfBirthMoment(): moment.Moment {
    return this._dateOfBirthMoment;
  }

  set dateOfBirthMoment(value: moment.Moment) {
    this._dateOfBirthMoment = value;
    this.dateOfBirth = value.toDate();
  }
}
